/**
* Services Filter JS
* -----------------------------------------------------------------------------
*
* All the JS for the Services Filter component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'services-filter',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // Scope to the component container (important in flexible content!)
      const filterSection = document.querySelector( '.services-filter' );
      if ( !filterSection ) return;

      const buttons = filterSection.querySelectorAll( '.service-filter-buttons button' );
      const selectDropdown = filterSection.querySelector( '.service-filter-select' );
      const serviceList = filterSection.querySelector( '#service-list' );

      // Read initial state from data attributes on the container
      let currentLocation = filterSection.dataset.initialLocation || '';
      let currentPage = parseInt( filterSection.dataset.initialPage, 10 ) || 1;

      // Remove trailing /page/1/ from URL on page load for cleaner URLs
      if ( /\/page\/1\/?$/.test( window.location.pathname ) ) {
        const cleanUrl = window.location.pathname.replace( /\/page\/1\/?$/, '/' );
        history.replaceState( null, '', cleanUrl );
      }

      // Update URL with current filter and page, without reloading
      function updateURL( location, page ) {
        let url = '/services/';
        if ( location ) url += location + '/';
        if ( page && page > 1 ) url += 'page/' + page + '/';

        if ( page > 1 ) {
          history.pushState( null, '', url );
        } else {
          history.replaceState( null, '', url );
        }
      }

      // Update active states for both buttons and select
      function updateActiveStates( location ) {
        // Update button states
        buttons.forEach( ( btn ) => {
          btn.classList.toggle( 'is-active', btn.getAttribute( 'data-location' ) === location );
        } );

        // Update select dropdown value
        if ( selectDropdown ) {
          selectDropdown.value = location;
        }
      }

      // Fetch services and update list + pagination
      function fetchServices( location = '', paged = 1, pushState = true ) {
        const loader = filterSection.querySelector( '.services-loader' );
        loader.style.display = 'block'; // show spinner
        serviceList.style.opacity = '0.5'; // optional: fade list
        const manualSelectedAttr = filterSection.dataset.manualSelected || '';
        const manualSelected = manualSelectedAttr ?
          manualSelectedAttr.split( ',' ).map( ( id ) => parseInt( id, 10 ) ) :
          [];
        const taxonomySelected = filterSection.dataset.taxonomyId || '';

        fetch( `${siteInfo.wpApiSettings.ll}fetch-services`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new URLSearchParams( {
            location: location,
            paged: paged,
            manual_selected: manualSelected.join( ',' ),
            taxonomy_id: taxonomySelected,
          } ),
        } )
            .then( ( response ) => {
              if ( !response.ok ) {
                return response.text().then( ( t ) => {
                  console.error( 'Server error body:', t ); throw new Error( 'Server error' );
                } );
              }
              return response.json();
            } )
            .then( ( data ) => {
              const tempDiv = document.createElement( 'div' );
              tempDiv.innerHTML = data.html;

              // Extract services
              const servicesHTML = Array.from( tempDiv.children )
                  .filter( ( el ) => !el.classList.contains( 'service-pagination' ) )
                  .map( ( el ) => el.outerHTML )
                  .join( '' );
              const paginationHTML = data.pagination || '';
              serviceList.innerHTML = servicesHTML;

              let paginationContainer = filterSection.querySelector( '.service-pagination' );
              if ( !paginationContainer ) {
                paginationContainer = document.createElement( 'nav' );
                paginationContainer.classList.add( 'service-pagination' );
                serviceList.insertAdjacentElement( 'afterend', paginationContainer );
              }
              paginationContainer.innerHTML = paginationHTML;

              // Rebind pagination clicks...
              const paginationLinks = paginationContainer.querySelectorAll( 'a.page-numbers' );
              paginationLinks.forEach( ( link ) => {
                link.addEventListener( 'click', function( e ) {
                  e.preventDefault();
                  let page = 1;
                  const pagedParamMatch = this.href.match( /[?&]paged=(\d+)/ );
                  const prettyPageMatch = this.href.match( /\/page\/(\d+)/ );

                  if ( pagedParamMatch ) {
                    page = parseInt( pagedParamMatch[1] );
                  } else if ( prettyPageMatch ) {
                    page = parseInt( prettyPageMatch[1] );
                  }

                  currentPage = page;
                  fetchServices( currentLocation, currentPage );
                  window.scrollTo( {top: 0, behavior: 'smooth'} );

                  updateURL( currentLocation, currentPage );
                } );
              } );

              if ( pushState ) updateURL( location, paged );
            } )
            .finally( () => {
              loader.style.display = 'none'; // hide spinner
              serviceList.style.opacity = '1';
            } );
      }

      // Handle filter changes (shared function for buttons and select)
      function handleFilterChange( location ) {
        currentLocation = location;
        currentPage = 1;

        updateActiveStates( currentLocation );
        fetchServices( currentLocation, currentPage );
        updateURL( currentLocation, currentPage );
      }

      // Handle filter button clicks
      buttons.forEach( ( button ) => {
        button.addEventListener( 'click', function() {
          const selectedLocation = this.getAttribute( 'data-location' );
          handleFilterChange( selectedLocation );
        } );
      } );

      // Handle select dropdown changes
      if ( selectDropdown ) {
        selectDropdown.addEventListener( 'change', function() {
          const selectedLocation = this.value;
          handleFilterChange( selectedLocation );
        } );
      }

      // Handle browser back/forward buttons
      window.addEventListener( 'popstate', () => {
        // Parse current URL to update state on back/forward
        function parseURL() {
          const path = window.location.pathname.replace( /^\/|\/$/g, '' );
          const parts = path.split( '/' );

          currentLocation = '';
          currentPage = 1;

          if ( parts[0] !== 'services' ) return;

          const segments = parts.slice( 1 );

          if ( segments.length === 0 ) {
            currentLocation = '';
            currentPage = 1;
            return;
          }

          if ( segments.length === 1 ) {
            if ( segments[0] === 'page' ) {
              currentPage = 1;
            } else {
              currentLocation = segments[0];
            }
          }

          if ( segments.length >= 2 ) {
            if ( segments[1] === 'page' && !isNaN( segments[2] ) ) {
              currentLocation = segments[0];
              currentPage = parseInt( segments[2], 10 );
            } else if ( segments[0] === 'page' && !isNaN( segments[1] ) ) {
              currentPage = parseInt( segments[1], 10 );
            }
          }
        }

        parseURL();

        // Update active states for both buttons and select
        updateActiveStates( currentLocation );

        fetchServices( currentLocation, currentPage, false ); // false = no pushState
      } );

      // Set initial active states on page load
      updateActiveStates( currentLocation );

      // Fetch initial services list without pushing new history state
      fetchServices( currentLocation, currentPage, false );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'services-filter', COMPONENT );
} )( app );
